import { render, staticRenderFns } from "./Basic.vue?vue&type=template&id=97aa50d0"
import script from "./Basic.vue?vue&type=script&lang=ts"
export * from "./Basic.vue?vue&type=script&lang=ts"
import style0 from "./Basic.vue?vue&type=style&index=0&id=97aa50d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports